import React from "react";
import { useBestOf } from "../context/BestOf";
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const SwitchButton = ({ value }: any) => {
  const {state, dispatch} = useBestOf();

  const handleChange = (e: any) => {
    dispatch({type: "UPDATE_TITLE_GENERATE", payload: {generate: !state.title.generate}})
  };
  return (
    <FormControlLabel
      value="Generate Title"
      control={
        <Checkbox
        color="primary"
        value={state.title.generate.toString()}
        onChange={handleChange} />
      }
      label="Generate Title"
      labelPlacement="start"
    />
  );
};
export default SwitchButton;
